import * as React from 'react';

import { AnimatedButton } from 'components/Map/AnimatedButton';
import styles from './SaveItineraryButton.module.css';
import { Itinerary } from 'models/itinerary';
import { useChatTranslation } from 'hooks/useChatTranslation';
import { useUrlQueryDisplayState } from 'components/Map/useUrlQueryDisplayState';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';

export const SaveItineraryButton = ({
  itinerary,
  onCloseChat,
}: {
  itinerary: Itinerary;
  onCloseChat: () => void;
}) => {
  const { t } = useChatTranslation();
  const { pushUrlParams } = useUrlQueryDisplayState();

  return (
    <div className={styles.container}>
      <AnimatedButton
        className={styles.btn}
        clickedClassName={styles.clicked}
        onClick={() => {
          MapDisplayContextService.setNewItinerary(itinerary);
          pushUrlParams({ pg: 'ITINERARIES.EDIT', nav: 'map' });
          onCloseChat();
        }}
      >
        <img src="/static/images/map/route.svg" alt="" className={styles.icon} />
        <div className={styles.text}>{t('Save this Itinerary')}</div>
      </AnimatedButton>
    </div>
  );
};
